import { render, staticRenderFns } from "./AuthorizationsStepsShowPage.vue?vue&type=template&id=58911afc&scoped=true&"
import script from "./AuthorizationsStepsShowPage.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsStepsShowPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationsStepsShowPage.vue?vue&type=style&index=0&id=58911afc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58911afc",
  null
  
)

export default component.exports